// AdSense configuration. Read at call time so tests (and a rebuild with other
// env vars) can switch modes. See docs/ADSENSE_STRATEGY.md.
//
//   REACT_APP_ADS_MODE       off | placeholder | live
//                            default: placeholder in development, off in production builds
//   REACT_APP_ADSENSE_CLIENT ca-pub-XXXXXXXXXXXXXXXX (required for live)
//   REACT_APP_ADSENSE_SLOTS  JSON map of placement -> ad-unit slot id, e.g. {"home-mid":"1234567890"}

export const ADSENSE_SRC = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";

/** Placement ids used in the pages, with the ad format each one reserves space for. */
export const PLACEMENTS = {
  "home-mid": { format: "horizontal" },
  "list-inline": { format: "horizontal" },
  "search-results": { format: "horizontal" },
  "book-after-content": { format: "horizontal" },
  "book-rail": { format: "rectangle" },
  "person-after-bio": { format: "horizontal" },
  "thread-after-post": { format: "horizontal" },
};

/** Reserved height per format and breakpoint, so a slot never shifts the page. */
export const FORMATS = {
  horizontal: { mobile: 100, desktop: 90 },
  rectangle: { mobile: 250, desktop: 250 },
};

// Never on these: admin, sign-in and account-recovery flows, and personal pages.
const BLOCKED = [/^\/control-panel/, /^\/login/, /^\/signup/, /^\/forgot-password/,
  /^\/reset-password/, /^\/auth-callback/, /^\/profile/];

export const adsAllowedOn = (pathname) => !BLOCKED.some((re) => re.test(pathname));

function slotIds() {
  try { return JSON.parse(process.env.REACT_APP_ADSENSE_SLOTS || "{}"); } catch { return {}; }
}

/** off | placeholder | live, for one placement. Live needs a client id and that placement's slot id. */
export function adMode(placement) {
  const mode = process.env.REACT_APP_ADS_MODE || (process.env.NODE_ENV === "production" ? "off" : "placeholder");
  if (!PLACEMENTS[placement] || mode === "off") return "off";
  if (mode === "live") {
    return process.env.REACT_APP_ADSENSE_CLIENT && slotIds()[placement] ? "live" : "off";
  }
  return "placeholder";
}

export const adSlotId = (placement) => slotIds()[placement] || "";
export const adClient = () => process.env.REACT_APP_ADSENSE_CLIENT || "";

let scriptInjected = false;
/**
 * Add the AdSense script once, on the first live slot, never from index.html:
 * pages without ads (admin, sign-in) then never run third-party code.
 */
export function loadAdSense() {
  if (scriptInjected || document.querySelector("script[data-hs-adsense]")) { scriptInjected = true; return; }
  const s = document.createElement("script");
  s.async = true;
  s.src = `${ADSENSE_SRC}?client=${encodeURIComponent(adClient())}`;
  s.crossOrigin = "anonymous";
  s.setAttribute("data-hs-adsense", "");
  document.head.appendChild(s);
  scriptInjected = true;
}

/** True once the ad script has been added to this document. */
export const adScriptPresent = () => !!document.querySelector("script[data-hs-adsense]");

export function __resetForTests() { scriptInjected = false; }
